import { gql } from "@apollo/client";

export const GET_PUBLIC_ROUTINE_BACTERIOLOGICAL_SAMPLING_REQUIREMENT = gql`
  query GetPublicRoutineBacteriologicalSamplingRequirement($systemId: Int!) {
    getPublicRoutineBacteriologicalSamplingRequirement(systemId: $systemId) {
      systemId
      facilityId
      sampleCount
      sampleFrequency
      sampleType
      scheduleBeginDate
      scheduleEndDate
      operatorStartDay
      operatorStartMonth
      operatorEndDay
      operatorEndMonth
      facilityCodeString
      facilityDetail {
        facilityId
        facilityName
        lastSampleDate
        nextSampleDue
      }
    }
  }
`;

export const GET_PUBLIC_TOTAL_COLIFORM_SAMPLE_HISTORY = gql`
  query GetPublicTotalColiformSampleHistory($systemId: Int!, $fromDate: Date!, $toDate: Date!) {
    getPublicTotalColiformSampleHistory(systemId: $systemId, fromDate: $fromDate, toDate: $toDate) {
      systemId
      collectionDate
      routineNoSample
      routineTcPos
      routineEcoliPos
      repeatNoSample
      repeatEcoliPos
      repeatTcPos
      triggeredNoSample
      triggeredEcoliPos
      triggeredTcPos
      otherSamplesReq
      otherNoSample
      otherTcPos
      otherEcoliPos
      sampleHistory
    }
    getTotalColiformLastSampleTakenInfo(systemId: $systemId, fromDate: $fromDate, toDate: $toDate){
      value
    }
  }
`;

export const GET_PUBLIC_SOURCES = gql`
  query GetPublicSources($systemId: Int!) {
    getPublicSources(systemId: $systemId) {
      systemId
      sourceId
      sourceName
      status
      sourceType
      waterType
      startDay
      startMonth
      endDay
      endMonth
      opDate
      abandoned
    }
  }
`;
